import { CreateUserAttributes } from "../types/user";
import CustomError from "../utils/custom-error";
const USER_SERVICE_API_BASE_URL = '';

export type EligibilityCheckType = { name: string; email: string };

export async function postEligibilityCheck(userData: EligibilityCheckType) {
  const url = USER_SERVICE_API_BASE_URL + "/auth/user/check-eligibility";

  console.log("Eligibility data: ", userData);
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(userData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();
  console.log("Data: ", data);
  console.log("Response: ", response);
  if (!response.ok || data.status !== "success") {
    const error = new CustomError(
      response.status,
      "Error checking eligibility",
      await data
    );
    console.log("Error here...");
    throw error;
  } else {
    return data.data;
  }
}

export async function postSignup(signupData: Partial<CreateUserAttributes>) {
  const url = USER_SERVICE_API_BASE_URL + "/auth/user/signup";
  console.log("signup data:", signupData);
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify({
      data: signupData,
      activationUrl: "http://localhost:3000/auth/verify-email",
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();
  console.log("Data: ", data);
  if (!response.ok || data.success === "success") {
    const error = new CustomError(
      response.status,
      "An error occurred while signing up",
      response.status === 500
        ? { message: "An error occured. Please try again later" }
        : await data
    );

    throw error;
  } else {
    return { user: data.data?.user, token: data.token };
  }
}

export async function postVerifyEmail(token: string | undefined) {
  if (!token) {
    throw new CustomError(500, "An error occurred while verifying sign in", "");
  }

  console.log("updateData: ", token);
  const url = USER_SERVICE_API_BASE_URL + `/auth/activate-account/${token}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  console.log("Data: ", data);
  if (!response.ok || data.status === "error") {
    const error = new CustomError(
      response.status,
      "An error occurred while verifying sign in",
      data
    );
    throw error;
  } else {
    return data;
  }
}

export async function postSignin(signinData: {
  email: string;
  password: string;
}) {
  const url = USER_SERVICE_API_BASE_URL + "/auth/signin";

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(signinData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();

  if (!response.ok || data.status === "error") {
    const error = new CustomError(
      response.status,
      "An error occurred while signing in",
      await data
    );
    throw error;
  } else {
    if (data.data?.message) {
      return { mfaSignIn: true, message: data.data.message, token: data.token };
    } else {
      localStorage.setItem('token',data.token);
      localStorage.setItem('user',JSON.stringify(data.data.user));
      return { mfaSignIn: false, user: data.data.user, token: data.token };
    }
  }
}

export async function postMfaSignin(reqData: {
  code: string;
  token: string | undefined;
}) {
  const { token, ...mfaCode } = reqData;

  if (!token) {
    throw new CustomError(500, "An error occurred while verifying sign in", "");
  }
  const url = USER_SERVICE_API_BASE_URL + "/auth/mfa/signin";

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(mfaCode),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  console.log("Data: ", data);
  if (!response.ok || data.status === "error") {
    const error = new CustomError(
      response.status,
      "An error occurred while verifying sign in",
      data
    );
    throw error;
  } else {
    return data;
  }
}

export async function postForgotPassword(reqData: {
  resetUrl: string;
  email: string;
}) {
  const url = USER_SERVICE_API_BASE_URL + "/auth/forgot-password";

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(reqData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();

  console.log("Data: ", data);
  if (!response.ok || data.status !== "success") {
    throw new CustomError(response.status, "An error occurred", data);
  } else {
    return data;
  }
}

export async function patchResetPassword(passData: {
  password: string;
  confirmPassword: string;
  token: string;
}) {
  const { token, ...reqData } = passData;
  const url = USER_SERVICE_API_BASE_URL + "/auth/reset-password/" + token;

  const response = await fetch(url, {
    method: "PATCH",
    body: JSON.stringify(reqData),
    headers: {
      "Content-Type": "application/json",
    },
  });

  const data = await response.json();

  console.log("Data: ", data);
  if (!response.ok || data.status !== "success") {
    throw new CustomError(response.status, "An error occurred", data);
  } else {
    return data;
  }
}
